import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqsHomepage = [
  {
    question: "What is JK Associates?",
    answer:
      "JK Associates is a trusted consultancy and training organization dedicated to empowering individuals and businesses through professional development, legal advisory, and skill-based training solutions. Our mission is to create a generation of capable, confident, and career-ready professionals.",
  },
  {
    question: "What types of training programs do you offer?",
    answer:
      "We offer a wide range of professional training programs, including Accounting & Finance, Corporate Management, Regulatory License and Compliance, among others. Each program is designed to provide real-world knowledge and practical skills.",
  },
  {
    question: "Will I receive a certificate after finishing?",
    answer:
      "Absolutely! Upon successful completion, you’ll receive a joint certificate from JK Associates & Chartered Skills, officially recognizing your professional skills and achievements. This accredited certificate enhances your profile and gives you a competitive advantage in your career or business.",
  },
  {
    question: "Who can join JK Associates training programs?",
    answer:
      "Our programs are open to students, job seekers, and entrepreneurs who wish to enhance their knowledge, boost their skills, or grow their business confidence. No matter your background, we have a course tailored for your goals.",
  },
  {
    question: "Are the trainers experienced?",
    answer:
      "Yes! All our trainers are industry experts, certified professionals, and experienced mentors who bring years of practical knowledge and teaching excellence to ensure you get the best learning experience possible.",
  },
  {
    question: "How are the training sessions conducted?",
    answer:
      "We offer in-person practical training sessions for flexibility and convenience. Each session includes interactive lectures, case studies, and hands-on projects to ensure effective learning.",
  },
  {
    question: "How can I enroll?",
    answer:
      "Enrollment is simple! Visit our office or website, choose your preferred course, and complete a quick registration process. Our team will guide you through every step.",
  },
  {
    question: "Why choose JK Associates?",
    answer:
      "Because we combine trust, expertise, and innovation. With a proven track record in consultancy, JK Associates ensures that every learner receives practical skills, career-oriented learning, and professional recognition.",
  },
];

const FAQSectionHomepage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => setOpenIndex(openIndex === index ? null : index);

  const faqStyle = (isOpen) => ({
    backgroundColor: isOpen ? "#0d6efd" : "#fff",
    color: isOpen ? "#fff" : "#333",
    borderRadius: "12px",
    padding: "18px 20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "all 0.3s",
  });

  const answerStyle = {
    marginTop: "10px",
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#fff",
  };

  return (
    <section style={{ padding: "60px 20px", backgroundColor: "#f8f9fa" }}>
      {/* Header */}
      <div
        style={{
          backgroundColor: "#0d6efd",
          color: "white",
          padding: "40px 30px",
          borderTopLeftRadius: "40px",
          borderBottomRightRadius: "10px",
          marginBottom: "40px",
        }}
      >
        <h2 style={{ fontSize: "32px", marginBottom: "15px" }}>
          Frequently Asked Questions
        </h2>
        <p style={{ fontSize: "16px", lineHeight: "1.6", margin: 0 }}>
          Answers to common questions about JK Associates and our training programs.
        </p>
      </div>

      {/* FAQ List */}
      <div style={{ display: "flex", flexDirection: "column", gap: "15px", maxWidth: "900px", margin: "0 auto" }}>
        {faqsHomepage.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={index} style={faqStyle(isOpen)} onClick={() => toggleFAQ(index)}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontWeight: "600", fontSize: "16px" }}>{faq.question}</span>
                {isOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {isOpen && <p style={answerStyle}>{faq.answer}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FAQSectionHomepage;
